// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__1Bnl_","number":"Post_number__1ZaO6","content":"Post_content__3NnaE","title":"Post_title__2pI2R","url":"Post_url__xe5HE","metadata":"Post_metadata__1pRHD"};